(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ca-disclosures-script"] && !Shopify.designMode) return;
  try {
    const disclosureElementName = 'ca-disclosures'
  const reducedMotionQuery = '(prefers-reduced-motion: reduce)'

  class CaDisclosures extends HTMLElement {
    connectedCallback() {
      if (this.abortController) return

      this.abortController = new AbortController()
      this.animations = new Map()
      this.motionPreference = matchMedia(reducedMotionQuery)
      this.handleMotionChange = (event) => {
        if (event.matches) this.finishAnimations()
      }
      this.handleHashChange = () => this.openCurrentFragment()

      this.addEventListener('click', (event) => this.handleClick(event), {
        signal: this.abortController.signal,
      })
      this.motionPreference.addEventListener('change', this.handleMotionChange)
      window.addEventListener('hashchange', this.handleHashChange, { signal: this.abortController.signal })
      this.updateAliasWarnings()
      this.openInitialFragment()
    }

    disconnectedCallback() {
      this.abortController?.abort()
      this.abortController = null
      this.motionPreference?.removeEventListener('change', this.handleMotionChange)
      this.motionPreference = null
      this.handleMotionChange = null
      this.handleHashChange = null

      this.animations?.forEach((record, details) => {
        record.animation.cancel()
        record.content.style.removeProperty('overflow')
        details.open = record.opening
        details.removeAttribute('data-disclosure-closing')
      })
      this.animations = null
      this.updateAliasWarnings()
    }

    handleClick(event) {
      const summary = event.target.closest('summary')
      const details = summary?.parentElement
      if (!summary || details?.tagName !== 'DETAILS' || !details.hasAttribute('data-animated-disclosure')) return
      if (details.closest(disclosureElementName) !== this) return

      const current = this.animations.get(details)
      const opening = current ? !current.opening : !details.open
      this.updateFragment(details, opening)
      if (this.motionPreference.matches) return

      const content = details.querySelector(':scope > [data-disclosure-content]')
      if (!content || typeof content.animate !== 'function') return

      event.preventDefault()
      this.toggle(details, content)
    }

    currentFragmentDisclosure() {
      if (!window.location.hash) return null

      let fragment
      try {
        fragment = decodeURIComponent(window.location.hash.slice(1))
      } catch {
        return null
      }

      if (document.getElementById(fragment)) return null

      const aliasTargets = this.disclosuresWithAlias(fragment)
      return aliasTargets.length === 1 ? aliasTargets[0] : null
    }

    openCurrentFragment() {
      const details = this.currentFragmentDisclosure()
      if (!details || details.closest(disclosureElementName) !== this) return

      this.openImmediately(details)
      let ancestor = details.parentElement?.closest('details[data-animated-disclosure]')
      while (ancestor) {
        ancestor.closest(disclosureElementName)?.openImmediately?.(ancestor)
        ancestor = ancestor.parentElement?.closest('details[data-animated-disclosure]')
      }
      details.querySelector(':scope > summary')?.scrollIntoView({ block: 'start' })
    }

    openImmediately(details) {
      const current = this.animations?.get(details)
      if (current) {
        current.animation.cancel()
        current.content.style.removeProperty('overflow')
        this.animations.delete(details)
        details.removeAttribute('data-disclosure-closing')
      }
      details.open = true
    }

    openInitialFragment() {
      if (document.readyState === 'complete') {
        this.openCurrentFragment()
        return
      }

      window.addEventListener(
        'load',
        () => {
          window.requestAnimationFrame(() => {
            if (this.isConnected) this.openCurrentFragment()
          })
        },
        { once: true, signal: this.abortController.signal },
      )
    }

    fragmentForDisclosure(details) {
      const alias = details.dataset.deepLinkAlias?.trim()
      if (!alias || document.getElementById(alias)) return null

      const aliasTargets = this.disclosuresWithAlias(alias)
      return aliasTargets.length === 1 ? alias : null
    }

    deepLinkAliasDisclosures() {
      return Array.from(document.querySelectorAll('details[data-animated-disclosure][data-deep-link-alias]'))
    }

    disclosuresWithAlias(alias) {
      return this.deepLinkAliasDisclosures().filter((details) => details.dataset.deepLinkAlias.trim() === alias)
    }

    updateAliasWarnings() {
      if (!globalThis.Shopify?.designMode) return

      const disclosures = this.deepLinkAliasDisclosures()
      const counts = new Map()
      disclosures.forEach((details) => {
        const alias = details.dataset.deepLinkAlias.trim()
        if (alias) counts.set(alias, (counts.get(alias) || 0) + 1)
      })
      disclosures.forEach((details) => {
        const warning = document.getElementById(details.dataset.deepLinkWarningId)
        if (warning) warning.hidden = counts.get(details.dataset.deepLinkAlias.trim()) < 2
      })
    }

    updateFragment(details, opening) {
      let fragment = ''
      if (opening) {
        fragment = this.fragmentForDisclosure(details)
        if (!fragment) return
      } else {
        const fragmentDisclosure = this.currentFragmentDisclosure()
        if (fragmentDisclosure !== details && !details.contains(fragmentDisclosure)) return
      }

      const url = `${window.location.pathname}${window.location.search}${fragment ? `#${encodeURIComponent(fragment)}` : ''}`
      window.history.replaceState(window.history.state, '', url)
    }

    toggle(details, content) {
      const current = this.animations.get(details)
      if (current) {
        current.opening = !current.opening
        details.toggleAttribute('data-disclosure-closing', !current.opening)
        current.animation.reverse()
        return
      }

      const opening = !details.open
      const currentHeight = opening ? 0 : content.getBoundingClientRect().height
      if (opening) details.open = true
      details.toggleAttribute('data-disclosure-closing', !opening)

      content.style.overflow = 'hidden'
      const animation = content.animate(
        [
          { height: `${currentHeight}px`, opacity: opening ? 0.35 : 1 },
          { height: `${opening ? content.scrollHeight : 0}px`, opacity: opening ? 1 : 0.35 },
        ],
        {
          duration: opening ? 220 : 180,
          easing: opening ? 'cubic-bezier(0.25, 0.1, 0.25, 1)' : 'cubic-bezier(0.4, 0, 1, 1)',
          fill: 'both',
        },
      )
      const record = { animation, content, opening }
      this.animations.set(details, record)

      animation.onfinish = () => {
        if (this.animations.get(details) !== record) return
        this.animations.delete(details)
        if (!record.opening) details.open = false
        details.removeAttribute('data-disclosure-closing')
        animation.cancel()
        content.style.removeProperty('overflow')
      }
    }

    finishAnimations() {
      Array.from(this.animations.values()).forEach(({ animation }) => animation.finish())
    }
  }

  if (!customElements.get(disclosureElementName)) {
    customElements.define(disclosureElementName, CaDisclosures)
  }
  } catch(e) { console.error(e); }
})();

})();
